import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useBrandIconStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';

  const primaryText = isDarkTheme ? '#f8fafc' : '#0f172a';
  const accentText = isDarkTheme ? '#38bdf8' : '#0f6da8';
  const taglineColor = isDarkTheme ? theme.palette.text.secondary : '#4b5563';

  return {
    container: css({
      alignItems: 'center',
      display: 'flex',
      textDecoration: 'none',
      gap: theme.spacing(1.5),
      color: primaryText,
    }),
    logo: css({
      width: 42,
      height: 42,
      flexShrink: 0,
      filter: isDarkTheme ? 'brightness(1.15)' : 'none',
      [theme.breakpoints.up('md')]: {
        width: 52,
        height: 52,
      },
    }),
    wordmark: css({
      display: 'flex',
      flexDirection: 'column',
      lineHeight: 1.05,
      gap: theme.spacing(0.3),
    }),
    name: css({
      display: 'flex',
      alignItems: 'baseline',
      fontWeight: 700,
      letterSpacing: '-0.01em',
      fontSize: '1.4rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.2rem',
      },
    }),
    namePrimary: css({
      color: primaryText,
    }),
    nameAccent: css({
      color: accentText,
      marginLeft: theme.spacing(0.5),
    }),
    tagline: css({
      fontSize: '0.75rem',
      fontWeight: 500,
      letterSpacing: '-0.01em',
      color: taglineColor,
      whiteSpace: 'nowrap',
      // HA-481: it doesn't fit beside the theme toggle and menu on a phone.
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    }),
  };
};
